import { JobTaskTableFields } from '@/enums';
import { ColumnOption } from '@/common/types';

export const DEFAULT_TABLE_COLUMNS = [
    JobTaskTableFields.SUB_TYPE,
    JobTaskTableFields.STATUS,
    JobTaskTableFields.WORKFLOW_ID,
    JobTaskTableFields.TASK_DESCRIPTION,
    JobTaskTableFields.ELAPSED,
    JobTaskTableFields.START_TIME,
    JobTaskTableFields.END_TIME,
];

export const ALL_TABLE_COLUMNS = [
    ...DEFAULT_TABLE_COLUMNS,
    JobTaskTableFields.PROJECT,
    JobTaskTableFields.JOB_ID,
    JobTaskTableFields.TASK_SUMMARY,
    JobTaskTableFields.TASK_NAME,
    JobTaskTableFields.PARENT_ID,
];

export const REQUIRED_TABLE_COLUMNS = [JobTaskTableFields.SUB_TYPE, JobTaskTableFields.STATUS];

export const COLUMN_FIELD_LABEL_MAP = {
    [JobTaskTableFields.SUB_TYPE]: 'Type',
    [JobTaskTableFields.STATUS]: 'Status',
    [JobTaskTableFields.WORKFLOW_ID]: 'Workflow',
    [JobTaskTableFields.TASK_DESCRIPTION]: 'Task Description',
    [JobTaskTableFields.ELAPSED]: 'Elapsed Time',
    [JobTaskTableFields.START_TIME]: 'Start Time',
    [JobTaskTableFields.END_TIME]: 'End Time',
    [JobTaskTableFields.PROJECT]: 'Project',
    [JobTaskTableFields.JOB_ID]: 'Job ID',
    [JobTaskTableFields.TASK_SUMMARY]: 'Task Summary',
    [JobTaskTableFields.TASK_NAME]: 'Task Name',
    [JobTaskTableFields.PARENT_ID]: 'Parent ID',
};

export const COLUMN_OPTIONS: ColumnOption[] = [
    {
        name: JobTaskTableFields.SUB_TYPE,
        label: COLUMN_FIELD_LABEL_MAP[JobTaskTableFields.SUB_TYPE],
        isRequired: true,
    },
    {
        name: JobTaskTableFields.STATUS,
        label: COLUMN_FIELD_LABEL_MAP[JobTaskTableFields.STATUS],
        isRequired: true,
    },
    {
        name: JobTaskTableFields.WORKFLOW_ID,
        label: COLUMN_FIELD_LABEL_MAP[JobTaskTableFields.WORKFLOW_ID],
        isRequired: false,
    },
    {
        name: JobTaskTableFields.TASK_DESCRIPTION,
        label: COLUMN_FIELD_LABEL_MAP[JobTaskTableFields.TASK_DESCRIPTION],
        isRequired: false,
    },
    {
        name: JobTaskTableFields.ELAPSED,
        label: COLUMN_FIELD_LABEL_MAP[JobTaskTableFields.ELAPSED],
        isRequired: false,
    },
    {
        name: JobTaskTableFields.START_TIME,
        label: COLUMN_FIELD_LABEL_MAP[JobTaskTableFields.START_TIME],
        isRequired: false,
    },
    {
        name: JobTaskTableFields.END_TIME,
        label: COLUMN_FIELD_LABEL_MAP[JobTaskTableFields.END_TIME],
        isRequired: false,
    },
    {
        name: JobTaskTableFields.PROJECT,
        label: COLUMN_FIELD_LABEL_MAP[JobTaskTableFields.PROJECT],
        isRequired: false,
    },
    {
        name: JobTaskTableFields.JOB_ID,
        label: COLUMN_FIELD_LABEL_MAP[JobTaskTableFields.JOB_ID],
        isRequired: false,
    },
    {
        name: JobTaskTableFields.TASK_SUMMARY,
        label: COLUMN_FIELD_LABEL_MAP[JobTaskTableFields.TASK_SUMMARY],
        isRequired: false,
    },
    {
        name: JobTaskTableFields.TASK_NAME,
        label: COLUMN_FIELD_LABEL_MAP[JobTaskTableFields.TASK_NAME],
        isRequired: false,
    },
    {
        name: JobTaskTableFields.PARENT_ID,
        label: COLUMN_FIELD_LABEL_MAP[JobTaskTableFields.PARENT_ID],
        isRequired: false,
    },
];
